// @flow
import {translate as t} from '../view/translation'

export const createInfoWindowContent = (serviceProvider: ServiceProvider):string => {
  const title = `<h3>${serviceProvider.name}</h3>`
  const address = `<p>${serviceProvider.address ? serviceProvider.address: ''}</p>`
  const link = `<a href="/place-detail?place=${serviceProvider._links.self}">${t('Map.infoWindow.link')} <i class="fas fa-arrow-right"></i></a>`
  const content = `
    <div class="info-window">
     ${title} 
     ${address}
     ${link}
    </div>
  `
  return content
}